module.exports = __webpack_public_path__ + "static/excelExport-33f58b3f0a010d915fbea6239b352451.gif";